<template>
  <div class="form-dlg">
    <el-dialog
      title="详情"
      :visible.sync="showDlg"
      width="60%"
      @open="openForm"
      @closed="closedForm"
    >
      <div class="dialog-content">
        <el-form ref="form" :model="formData" :rules="rules" disabled label-width="120px">
          <el-form-item prop="customerName" label="客户姓名">
            <el-input v-model="formData.customerName" clearable></el-input>
          </el-form-item>
          <el-form-item prop="companyName" label="公司名称">
            <el-input v-model="formData.companyName" clearable></el-input>
          </el-form-item>
          <el-form-item prop="position" label="职位">
            <el-input v-model="formData.position" clearable></el-input>
          </el-form-item>
          <el-form-item prop="phoneNumber" label="手机号">
            <el-input v-model="formData.phoneNumber" clearable></el-input>
          </el-form-item>
          <el-form-item prop="companyAddress" label="公司地址">
            <el-input v-model="formData.companyAddress" clearable></el-input>
          </el-form-item>
          <el-form-item prop="nikeName" label="销售人员">
            <el-input v-model="formData.nikeName" clearable></el-input>
          </el-form-item>
          <el-form-item prop="channel" label="渠道">
            <el-input v-model="formData.channel" clearable></el-input>
          </el-form-item>
          <el-form-item prop="productName" label="商品名称">
            <el-input v-model="formData.productName" clearable></el-input>
          </el-form-item>
          <el-form-item prop="productImage" label="商品主图">
            <s-img
              :src="formData.productImage"
              alt=""
              class="img"
              style="width: 120px; height: 120px; border-radius: 8px;"
            ></s-img>
          </el-form-item>
          <el-form-item prop="productFirstCategory" label="商品一级类目">
            <el-input v-model="formData.productFirstCategory" clearable></el-input>
          </el-form-item>
          <el-form-item prop="productSecondCategory" label="商品二级类目">
            <el-input v-model="formData.productSecondCategory" clearable></el-input>
          </el-form-item>
          <el-form-item prop="productThirdCategory" label="商品三级类目">
            <el-input v-model="formData.productThirdCategory" clearable></el-input>
          </el-form-item>
          <el-form-item prop="dosageForm" label="药剂类型">
            <el-input v-model="formData.dosageForm" clearable></el-input>
          </el-form-item>
          <el-form-item prop="packagingMaterialType" label="内包装类型">
            <el-input v-model="formData.packagingMaterialType" clearable></el-input>
          </el-form-item>
          <el-form-item prop="outerPackaging" label="外包装类型">
            <el-input v-model="formData.outerPackaging" clearable></el-input>
          </el-form-item>
          <el-form-item prop="productIngredients" label="产品配料">
            <el-input v-model="formData.productIngredients" type="textarea" rows="4"></el-input>
          </el-form-item>
          <el-form-item prop="targetAudience" label="适用人群">
            <el-input v-model="formData.targetAudience" clearable></el-input>
          </el-form-item>
          <el-form-item prop="applicableScenariosStr" label="适用场景">
            <el-input v-model="formData.applicableScenariosStr" type="textarea" rows="4"></el-input>
          </el-form-item>
          <el-form-item prop="applicableScenarios" label="适用场景图片">
            <div class="imgs">
              <s-img
                v-for="(item, index) in formData.applicableScenarios || []"
                :key="index"
                :src="item && item.applicableImage"
                alt=""
                class="img"
                style="width: 120px; height: 120px; border-radius: 8px;"
              ></s-img>
            </div>
          </el-form-item>
          <el-form-item prop="advantageSummary" label="优势总结">
            <div
              v-if="formData.productAdvantages && formData.productAdvantages.length"
              class="imgs"
            >
              <s-img
                v-if="isImg(formData.productAdvantages[0].advantageSummary)"
                :src="formData.productAdvantages[0].advantageSummary"
                alt=""
                class="img"
                style="width: 120px; height: 120px; border-radius: 8px;"
              ></s-img>
              <span v-else>无</span>
            </div>
          </el-form-item>
          <el-form-item prop="advantageDescription" label="优势描述">
            <el-input v-model="formData.productAdvantagesStr" type="textarea" rows="5"></el-input>
          </el-form-item>
          <el-form-item prop="certsImg" label="质量认证图片">
            <s-img
              v-if="isImg(formData.certsImg)"
              :src="formData.certsImg"
              alt=""
              class="img"
              style="width: 120px; height: 120px; border-radius: 8px;"
            ></s-img>
            <span v-else>无</span>
          </el-form-item>
          <el-form-item prop="createTime" label="定制时间">
            <el-date-picker
              v-model="formData.createTime"
              type="datetime"
              placeholder="选择日期"
              clearable
            ></el-date-picker>
          </el-form-item>
          <el-form-item prop="customizationLike" label="点赞状态">
            <span>{{ formData.customizationLike }}</span>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getAiDet } from '@/api'
import { isImg } from '@/utils/util'
import SImg from '@/components/s-img'

export default {
  name: 'form-dlg',
  model: {
    prop: 'value',
    event: 'change',
  },
  components: {
    SImg,
  },
  props: {
    value: Boolean,
    data: Object,
  },
  data() {
    return {
      isImg,
      loading: false,
      formData: {
        imgs: [
          // {
          //   name: '',
          //   url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
          // },
        ],
      },
      rules: {},
    }
  },
  computed: {
    showDlg: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('change', val)
      },
    },

    // 编辑模式
    isUpdate() {
      return this.data && (this.data.id || this.data.id === 0)
    },
  },
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {
    // 重置表单
    resetForm() {
      this.$refs.form.resetFields()
    },

    // 弹窗打开
    openForm() {
      this.getData()
    },

    // 弹窗关闭动画结束
    closedForm() {
      this.resetForm()
    },

    getData() {
      getAiDet({
        id: this.data.id,
      }).then(res => {
        this.formData = res || {}
      })
    },
  },
}
</script>

<style lang="less" scoped>
.form-dlg {
  .dialog-content {
    overflow: auto;
    max-height: 50vh;
    .imgs {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
    }
  }
}
</style>
